import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceBase } from '../service.base';
import { AuthService, ResponseObject } from '../auth.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class WixService extends ServiceBase {
  private api = '/Wix';
  private userController = '/User';
  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }


  public wixAppInstallationLinkToConnectWithWix() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/wix-app-installation-link';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions);
  }

  public connectWithWixAccountApi(token: any) {
    const httpOptions = this.RequestHeaders();
    const method: string = `/login-with-wix`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    const body = {
      token: token
    };
    return this.http.post<ResponseObject>(url, body, httpOptions);
  }

  public getWIXAccountDetails(): Observable<WixSiteDetail> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/fetch-store-detail';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<WixSiteDetail>(url, httpOptions);
  }
  public onDisconnectWixAccount(): Observable<ResponseObject> {
    const method: string = '/disconnect';
    const url: string = environment.BASE_API_PATH + this.api + method;
    const httpOptions = this.RequestHeaders();
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

  public onWixAccountCallBack(Code: string, instanceId: string, state: string) {
    const method: string = '/store-token-callback';
    const url: string = `${environment.BASE_API_PATH}${this.api}${method}/${state}/${instanceId}`;
    const httpOptions = this.RequestHeaders();

    // Create an object with the property `code`
    const body = {
      code: Code // Use the provided Code value
    };

    console.log('wix store tokken callback body ', body);
    return this.http.post<ResponseObject>(url, body, httpOptions);
  }

  public hasAccountOnWix(): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/account-exists';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions);
  }
  public allowProductSyncOnWix() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/isAllowed-to-sync-product-on-wix';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<boolean>(url, httpOptions);
  }

  public storeCurrencyofWixWithExchangeRate(): Observable<PlateformCurrencyExchangeRate> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/fetch-store-currency-with-exchangeRate';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<PlateformCurrencyExchangeRate>(url, httpOptions);
  }



  public onProductSynctWix(consignmentId: string, productId: string, IsUserAddManullyRates: boolean): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/sync-single-product/${consignmentId}/${productId}/${IsUserAddManullyRates}`;
    const url = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }
  
  public generatePluginKey(): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/generete-plugin-key';
    const url: string = environment.BASE_API_PATH + this.userController + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

  public declinePluginKey(): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/decline-plugin-key';
    const url: string = environment.BASE_API_PATH + this.userController + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

}

export interface AllPlatformCurrencyExchangeRate {
  BasePlateform: string;
  ExchageRateSite: string;
  IntegratedPlateformCurrencyExchangeRate: PlateformCurrencyExchangeRate[];
}

export interface PlateformCurrencyExchangeRate {
  IsPlateformCurrencyIsDifferent: boolean;
  Plateform: string | null;
  BaseCurrencySymbol: string | null;
  TargetCurrencySymbol: string | null;
  ExchangeRate: number;
  ExchageRateSite: string;
  ResponseObject: ResponseObject;
}








export class WixSiteDetail {
  WixSiteProperties!: WixSiteProperties;
  WixSiteInfo!: WixSiteInfo;
  WisSiteConnectedAt!: string;
}

export class WixSiteInfo {
  locale!: string;
  multilingual!: Multilingual;
  paymentCurrency!: string;
  siteDisplayName!: string;
  url!: string;
  description!: string;
  ownerEmail!: string | null;
  ownerInfo!: any | null;
  siteId!: string;
}

export class Multilingual {
  isMultiLingual!: boolean;
  supportedLanguages!: string[];
}

export class WixSiteProperties {
  locale!: Locale;
  language!: string;
  paymentCurrency!: string;
  timeZone!: string;
  address!: Address;
  siteDisplayName!: string;
  businessConfig!: string;
  trackClicksAnalytics!: boolean;
}

export class Locale {
  languageCode!: string;
  country!: string;
}

export class Address {
  street!: string;
  city!: string;
  country!: string;
  state!: string;
  zip!: string;
  isPhysical!: boolean;
  googleFormattedAddress!: string;
  streetNumber!: string;
  apartmentNumber!: string;
}

export class CurrencyData {
  IsPlateformCurrencyIsDifferent!: boolean;
  Plateform!: string;
  BaseCurrencySymbol!: string;
  TargetCurrencySymbol!: string;
  ExchangeRate!: number;
}
